import { DBConnectorService } from './../../../service/test.service';
import { UserviewModel, users } from './../../../service/sector.model';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { ManageService } from '../../../service/manage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

// import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LoggedInGuard } from '../../../authentication/logged-in.guard';
export interface EditModal {
  User1: users;
  sectorlist: [];
  // title: string;
  // message: string;
}

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements EditModal, OnInit {

  public event: EventEmitter<boolean> = new EventEmitter();
  // title: string;
  // message: string;
  User1: users;
  sectorlist: [];
  SectorNameList = [];
  userdata = new UserviewModel;

  constructor(private manage: ManageService,
    private dbconnectorservice: DBConnectorService,
    public bsModalRef: BsModalRef,
    private loggedInGuard: LoggedInGuard) {
    // super(dialogService);
  }

  UserEdit() {
    if (this.loggedInGuard.isSessionValid()) {
      this.userdata.User = this.User1;
      this.userdata.User.Password = '1234Test';
      this.userdata.SectorList = this.SectorNameList;
      if (this.userdata.User.UserName != null) {
        this.manage.editUser(this.userdata)
          .subscribe(
            (data) => {
              console.log(data);
            });
      }
    }
  }


  confirm() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code
    this.UserEdit();
    this.event.emit(true)
    this.closeModal();
  }

  closeModal() {
    this.bsModalRef.hide();
    // this.close();
  }

  ngOnInit() {

  }

}
